// Generated by GitHub Copilot
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './JourneyCard.module.css';

/**
 * JourneyCard displays a GCC client journey scenario.
 * Shows a badge, large purple title, description, divider and pipe-separated links.
 *
 * @param {string}   badge         - Small label e.g. "Client Has No GCC".
 * @param {string}   title         - Large purple card heading.
 * @param {string}   description   - Short description paragraph.
 * @param {string[]} links         - Array of resource link labels shown at the bottom.
 * @param {string}   offeringSlug  - Route slug for the offering detail page.
 */
const JourneyCard = ({ badge, title, description, links = [], offeringSlug }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (offeringSlug) navigate(`/offering/${offeringSlug}`);
  };

  return (
    <article
      className={styles.card}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleClick(); }}
      aria-label={`View offerings for: ${title}`}
    >
      {/* Badge */}
      {badge && (
        <span className={styles.badge}>
          {badge}
        </span>
      )}

      {/* Title — large, purple */}
      <h3 className={styles.title}>
        {title}
      </h3>

      {/* Description */}
      <p className={styles.description}>{description}</p>

      {/* Divider */}
      <div className={styles.divider} aria-hidden="true" />

      {/* Links — pipe separated */}
      <div className={styles.links}>
        {links.map((link, i) => (
          <span key={link} className={styles.linkItem}>
            <span>{link}</span>
            {i < links.length - 1 && (
              <span className={styles.separator} aria-hidden="true">|</span>
            )}
          </span>
        ))}
      </div>
    </article>
  );
};

export default JourneyCard;
